import {defineStore} from 'pinia'
import api from '@/services/api'

export const useProductVariationsStore = defineStore('productVariations', {
    state: () => ({
        data: {}
    }),
    
    actions: {
        set({tableName, id, displayOrder}) {
            if (!this.data[tableName]) {
                this.data[tableName] = {}
            }
            
            this.data[tableName][id] = displayOrder
        },
        
        async getVariation({productId, variationId}) {
            if (productId) {
                const response = await api.get('api/product-variation-option-data', {
                    params: {
                        productId: productId,
                        variationId: variationId
                    }
                })
                
                return response.data.map(o => ({
                    name: o.option.title,
                    value: o.variable.title
                }))
            }
        }
    }
})